import Img from 'gatsby-image';
import styled from 'styled-components';

import UI from '#front-credpago';

import BgLines from '../../../images/cp-lines.png';
import globals from '../../globals';

const { containerMaxWidth } = globals;

export const FullWidthWrapper = styled.section`
  display: flex;
  max-height: 100%;
  height: 100vh;

  background: url(${BgLines}) no-repeat center center;
  background-size: auto 100%;
  position: relative;

  @media ${UI.globals.mediaqueries.md} {
    padding-left: 20px;
    background-size: auto 80%;

    .text-wrapper {
      p {
        max-width: 340px !important;
        margin-bottom: 80px;
      }
    }

    height: ${(props) => (props.smallOnMdScreen ? '550px' : 'inherit')};
  }

  @media ${UI.globals.mediaqueries.lg} {
    height: 90vh;

    .text-wrapper {
      p {
        max-width: 480px !important;
        margin-bottom: 80px;
      }
    }
  }

  @media screen and (min-width: 769px) and (max-width: 1024px) {
    .text-wrapper {
      p {
        max-width: 450px !important;
        margin-bottom: 80px;
      }
    }
  }
`;

export const Container = styled.div`
  width: 100%;
  max-width: calc(${containerMaxWidth} + 40px);
  margin: 0 auto;
  align-self: center;
  position: relative;

  @media ${UI.globals.mediaqueries.md} {
    align-self: flex-start;
  }
`;

export const FixedBottom = styled.div`
  position: absolute;
  left: 0;
  width: 100%;
  bottom: 250px;

  @media ${UI.globals.mediaqueries.md} {
    bottom: 10px;
  }

  @media ${UI.globals.mediaqueries.lg} {
    bottom: 180px;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;

  .icon-wrapper svg {
    width: 13px;
  }
`;

export const WrapperImg = styled.div`
  position: relative;
`;

export const ImgHand = styled(Img)`
  position: absolute;
  left: 140px;

  @media ${UI.globals.mediaqueries.xs}, ${UI.globals.mediaqueries.sm} {
    left: 60px;
  }

  @media ${UI.globals.mediaqueries.md}, ${UI.globals.mediaqueries.lg} {
    left: -70px;
    width: 140%;
  }
`;
